import React from 'react';

import './Header.css';

import loginButton from 'assets/images/login-button.png';
import logo from 'assets/images/logo.png';

function Header(props) {
  const isLogged = props.isLogged;

  const handleBrandClick = () => {
    props.onHomeButtonClicked();
  }

  const headerClassName = `header ${isLogged ? 'header-solid' : 'header-overlay'}`;

  return (
    <>
      <header className={headerClassName}>
        <div
          onClick={handleBrandClick}
          className="brand-row"
        >
          <img className="logo" src={logo} alt="Unbot" />
          <label className="brand">Unbot</label>
        </div>

        <div className="header-layout-actions">
          {props.actions}
          {
            !isLogged &&
            <div
              className="user-icon"
              onClick={props.onLoginButtonClicked}
            >
              <img src={loginButton} alt="Login" />
            </div>
          }
        </div>
      </header>
    </>
  );
}

export default Header;
